<template>
  <m-card
    no-padding
    class="create-space-card"
  >
    <m-content
      padding-xs
    >
      <div class="_top">
        <icon-picker
          :emoji="emoji === null ? '': emoji"
          show-placeholder
          size="3.2rem"
          bordered
          class="_emoji-picker"
          @change="setEmoji"
          @remove="emoji = ''"
        />
        <m-text-field
          v-model:value="title"
          auto-focus
          :placeholder="$t('createSpaceCard.placeholder')"
          @keydown="maybeSubmit"
        />
      </div>
      <m-divider
        no-border
        xxs
      />
      <div
        class="_actions"
      >
        <m-btn
          block
          color="primary"
          :loading="loading"
          @click="submit"
        >
          <template v-if="isUpdate">
            {{ $t('general.save') }}
          </template>
          <template v-else>
            {{ $t('general.create') }}
          </template>
        </m-btn>
      </div>
    </m-content>
  </m-card>
</template>

<script>
import IconPicker from '@/components/IconPicker.vue';
import useSpaces from '@/composables/space/spaces';
import { SPACE_DETAILS } from '@/route-names';
import { logCatch } from '@/lib/logger/logger';

export default {
  name: 'CreateSpaceCard',
  props: {
    entity: {
      type: Object,
      default: () => null,
    },
    parent: {
      type: Object,
      default: () => null,
    },
  },
  setup() {
    const spacesSvc = useSpaces();
    return { spacesSvc };
  },
  emits: ['created', 'updated'],
  components: { IconPicker },
  data() {
    return {
      title: '',
      emoji: '',
      loading: false,
    };
  },
  computed: {
    isCreate() {
      return this.entity === null && this.parent === null;
    },
    isUpdate() {
      return this.entity !== null;
    },
    isAddChild() {
      return this.entity === null && this.parent !== null;
    },
  },
  methods: {
    setEmoji(emoji) {
      this.emoji = emoji;
    },
    submit() {
      if (this.isCreate) {
        this.create();
        return;
      }
      if (this.isAddChild) {
        this.addChild();
        return;
      }
      this.update();
    },
    maybeSubmit(event) {
      if (event.key === 'Enter') {
        this.submit();
      }
    },
    addChild() {
      this.loading = true;
      const entity = {
        title: this.title,
        icon: this.emoji,
        parents: [this.parent],
      };
      this.spacesSvc.createSpace(entity).then((data) => {
        this.$router.push({ name: SPACE_DETAILS, params: { optionId: data.uid } });
        this.$emit('created', data);
      })
        .catch(logCatch(() => {
          this.$showSnackbar({ color: 'error', message: this.$t('error.default') });
        }))
        .finally(() => {
          this.loading = false;
        });
    },
    update() {
      this.loading = true;
      this.spacesSvc.updateSpace(
        {
          uid: this.entity.uid,
          title: this.title,
          icon: this.emoji,
        },
      ).then((data) => {
        this.$emit('updated', data);
      }).catch(logCatch(() => {
        this.$showSnackbar({ color: 'error', message: this.$t('error.default') });
      }))
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.loading = true;
      this.spacesSvc.createSpace(
        {
          title: this.title,
          icon: this.emoji,
        },
      ).then((data) => {
        this.$router.push({ name: SPACE_DETAILS, params: { optionId: data.uid } });
        this.$emit('created', data);
      })
        .catch(logCatch(() => {
          this.$showSnackbar({ color: 'error', message: this.$t('error.default') });
        })).finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.isUpdate) {
      this.title = this.entity.title;
      this.emoji = this.entity.icon;
    }
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .create-space-card {
    ._top {
      display: flex;

      ._emoji-picker {
        margin-right: .8rem;
      }
    }
  }

</style>
